export enum PipelineScope {
  DRIVER = "driver",
  PIPELINE_STEP = "pipelineStep",
  PIPELINE = "pipeline"

}